import EditParticipant from './EditParticipantContainer';
export default EditParticipant;
